// @flow
import * as React from "react";
import styled, { css } from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  width: 100%;
  height: 45px;
  padding: 0 8px;
  background-color: ${props => props.theme.oneSignalHeaderBg};
`;

const Logo = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left center;
`;

const LogoView = styled(Logo)`
  width: 29px;
  height: 23px;
  margin: 0 10px;
  background-image: url(${props => props.theme.indexLogo});

  ${props =>
    props.thProject &&
    css`
      margin-top: -3px;
      width: 34px;
      height: 22px;
    `};
`;

const LogoText = styled(Logo)`
  width: 79px;
  height: 19px;
  background-image: url(${props => props.theme.headerLogoText});

  ${props =>
    props.thProject &&
    css`
      width: 70px;
      height: 13px;
    `};
`;

const Svg = styled.svg`
  width: 29px;
  height: 29px;
  margin-left: auto;
`;

const Transparent = styled.path`
  fill: none;
`;

const Colored = styled.path`
  fill: ${props => props.theme.accent};
`;

function Header(props: {}) {
  return (
    <Container>
      <LogoView thProject={process.env.REACT_APP_DEPLOY_TARGET === "siamoption"} />
      <LogoText thProject={process.env.REACT_APP_DEPLOY_TARGET === "siamoption"} />

      <Svg xmlns="http://www.w3.org/2000/svg" viewBox="460.4 83 33.199 33.199">
        <g transform="matrix(0.839, 0.545, -0.545, 0.839, 473.472, 83)">
          <Transparent d="M0,0H24V24H0Z" />
          <Colored d="M7.58,4.08,6.15,2.65A10.425,10.425,0,0,0,2.03,10.5h2A8.446,8.446,0,0,1,7.58,4.08ZM19.97,10.5h2a10.489,10.489,0,0,0-4.12-7.85L16.43,4.08A8.5,8.5,0,0,1,19.97,10.5ZM18,11c0-3.07-1.64-5.64-4.5-6.32V4a1.5,1.5,0,0,0-3,0v.68C7.63,5.36,6,7.92,6,11v5L4,18v1H20V18l-2-2ZM12,22a1.752,1.752,0,0,0,.4-.04,2.029,2.029,0,0,0,1.44-1.18,2.008,2.008,0,0,0,.15-.78h-4A2.014,2.014,0,0,0,12,22Z" />
        </g>
      </Svg>
    </Container>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/OneSignal/Header.js